/*For now Implies Highlight -- Really the Base */
// really a wrapper around a raphael element -- that could be it's own view (events delegated/undelegated)


 var Raphael = require('raphael'),
     RaphaelView = require('raphaelItemView'),
     $ = require('jquery'),
     _ = require('underscore'),
     ShapeMoveFns = require('./moveFns/shapeViewMoveFns'),
     ShapeResizeFnsFactory = require('./resizeFns/factory'),
     SelectHandles = require('./selectSet/selectHandles'),
     SelectBoxView = require('./selectSet/selectBox'),
     BtnSet = require('./selectSet/btn/buttonSet');


var instVars = {

    parent: null, // TODO: rid  ... used for mouseInBounds fn
    shapeModel: null,
    shapeUI: null,
    pgNoteModel: null, //TODO: can now get via resresp
    paper: null, // TODO: necessary? -- getting the dragHandle on drawStart -- rid and renderFromModel -- this.paper.path()
    channel: null,

    /* later added */
    dragHandle: null,
    glow: null, // R.set from glow
    handleSet: null,
    borderView: null //depends on subShapeType

    // ShapeResizeFns: resizeStart, resizeMove, resizeEnd
    // MoveFns: moveStart, moveMove, moveEnd
    // bounds
        // this.obox = this.el.getBBox();
        // this.obx = this.obox.x; //use as origin!
        // this.oby = this.obox.y;

    // borderView -- optional
};


/* Note: base in the 'coordinate */
var ShapeView = RaphaelView.extend({  /* init from set or r element */

    initialize: function(options) {

        _.extend( this, instVars, _.pick(options, 'shapeModel', 'pgNoteModel', 'parent', 'channel'), {
            shapeUI: options.shapeModel.uiModel, /*cache*/
            paper: options.parent.paper
        });

        this.bindEntityEvents(this.shapeUI,     this.shapeUIEvents);
        this.bindEntityEvents(this,             this.shapeSubs); /* events triggered off self ... legacy ...*/

        _.bindAll(this, '_selectClickedShape');

    },
    shapeUIEvents: {
        'change:isActive':              'toggleActive',     /* Indicates the note of the shape is active -- activate/deactivate -- TODO: could move to on render */
        'change:isExpanded':            'toggleExpanded',   /* Indicates the note of the shape is expanded -- setExpanded/unsetExpanded -- TODO: could move to onRender */
        'change:isSelected':            'toggleSelected',   /* select/unSelect */
        'change:isHighlighted':         'toggleGlow',        /* highlight/unHighlight */
        'shape:consultGroupChange':     'noteConsultGroupChange', // not an attribute on shapeUI; trigger off here for convenience with listener already set

        // TODO: F&R : now using same view
        'change:isMouseOverFindAndRedactHitView': 'toggleGlow', // utilizing for toggle from hit view
        'change:isHitApplied':                    'toggleApplied'

    },
    /*
    * Shape events fired off themselves
    * Note: there are more, not all listened to off the base here -- eg: shape.move shape.resizeRect ... should inventory
    * */
    shapeSubs: {

        'shape.scaleWithPaper':          '_scaleWithPaper',

        // TODO: F&R - though now may want to update all shapes live ( canvas-re-render)
        'shape.moveEnd shape.resizeEnd': 'persistPosition'

    },
    events: {
        'mouseover': 'onEnterMouseHover',
        'mouseout':  'onExitMouseHover'
    },

    /**
     * TODO:
     * - now passing in sm for fns that ref the proto change to options
     * - for non graphic, still need paper first -- must draw; way around this ?
     * - (could now get fromModel from shapeUI.isNewlyDrawn)
     * - _renderFromModel: this was working but incorrect -- for signatures, s/b be calling the overwritten method on graphic notes, not this
     * - this.shapeUI.set({raphaelEl: rEl}): should be stored first in parse for graphic ... but actually doesn't exist until render -- can move to parse
     */
    render: function(sm, scale, channel, fromModel) {

        if (fromModel) {
            var rEl = this._renderFromModel.apply(this, arguments);
            this.shapeUI.set({raphaelEl: rEl}); // stored (just created now)
        }

        this.setElement( this.shapeUI.raphaelEl() );
        this._hideIfAutoDisplay();
        this.triggerMethod('afterRender'); // Don't need to ref proto


        // TODO: temp for find and redact -- need to move logic to render: -- quick hack due to re-render of canvas mouse if over and you 'goToHit')
        if ( this.shapeUI.get('isMouseOverFindAndRedactHitView') )
            this.toggleGlow();

        return this;

    },
    /*
    * ( Alternative is shape drawn on canvas -- then created into shape view) )
    * */
    _renderFromModel: function( shapeModel, scale ) {

        return this.paper
            .path( shapeModel.getPathToRenderFromModel(scale) )
            .attr( shapeModel.getNonPathInactiveSVGAttrs( this.channel) );


    },
    onEnterMouseHover: function(e) {

        if ( this.shapeModel.isFindAndRedactShape ) {
            this.toggleIsMouseOverFindAndRedactShape( e, true );
            return;
        }

        /**
         * DVBC-1740 -- don't stop propagation if edit mode
         * - toggleMouseOver functionality doesn't apply here anyway
         * - need to allow mouseenter event to be captured by the page canvas to show hovershapes
         */
        if ( this.channel.request('editMode') )
            return;


        e.preventDefault();
        e.stopImmediatePropagation(); /* NOTE: will take the lowest -- event not prop'ing up through layers -- solves overlap problem */

        this.channel.trigger('shapeView:toggleMouseOver', this.pgNoteModel, {isEntering: true });


    },
    onExitMouseHover: function(e) {

        if ( this.shapeModel.isFindAndRedactShape ) {
            this.toggleIsMouseOverFindAndRedactShape( e, false );
            return;
        }

        // DVBC-1740 -- see comment in onEnterMouseHover ( don't stop propagation in edit mode )
        if ( this.channel.request('editMode') )
            return;

        e.preventDefault();
        e.stopImmediatePropagation(); /* NOTE: will take the lowest -- event not prop'ing up through layers -- solves overlap problem */

        this.channel.trigger('shapeView:toggleMouseOver', this.pgNoteModel, {isEntering: false });

    },

    /**
     * Area for F&R subclass / refactor.
     * Also wouldn't want to allow if not one of these shapes, a note view wouldn't exist and RTE would occur.
     * Here we also want to trigger the shape, not the model
     * Note: F&R also allowed with edit mode -- see DVBC-1740
     * See overlap with DVBC AND EDIT MODE -- you could be in 'both modes'
     * Should also: /mediate/cache/reuse hitsCollection
     */
    toggleIsMouseOverFindAndRedactShape: function( e, isMouseOverShape ) {

        e.preventDefault();
        e.stopImmediatePropagation();

        var hitModelOfShape =
            this.channel.request('vChannel')
                .request('findAndRedactSearchModel')
                .get('searchResults').getHitById( this.shapeModel.get('hitId') );

        // For now send event with a direct ref
        hitModelOfShape.set( 'isMouseOverCanvasShape', isMouseOverShape );

    },


    // Now only enter: canvas-re-rendered prior and exit wouldn't exist --> could just move to render
    toggleActive: function() {

        /*
         * TODO:
         * - subclass on graphic note shape model
         * - Diff shape models will rid need for this ...
         *   I think subtype only applicable at note level with graphic notes ( but move to shapeModels anyway )
         * */
        var isNotGraphicNote = !this.pgNoteModel.isSVGGraphicNote();

        isNotGraphicNote &&
            this.el.attr( this.shapeModel.getNonPathActiveSVGAttrs( this.channel )  );

        /* note: cursor must come after or the other props will override it) */
        this.el.attr('cursor', 'pointer');
        this._enableSelect();


        /* must put front of other shapes so that their cursor doesn't go in front of this one */
        this.el.toFront();
        this._showIfAutoDisplay();
        
    },

    toggleSelected: function(ui, isSelected) {

        if (isSelected) {
            this._enableMove();  //!order of events matters -- need to move
            this.setResizeFns();
            this._disableSelect();
            // *DOING THIS LAST FIXES ISSUE WITH INABILITY TO DRAW UPON ENTER EDIT/CREATE WITHOUT HACK -- TODO: put b/f would speed up */
            this._createSelectSet();  /* PROB B/C IT MUST BE SET AFTER DISABLE SELECT */

        } else {
            this._destroySelectSet();
            this.el.attr('cursor', 'pointer');  //active, but not selected ( or allow to draw on it ...)
            this._disableMove();
            this._enableSelect();
        }

    },

    toggleApplied: function() {

        this.el.attr( this.shapeModel.getNonPathActiveSVGAttrs( this.channel ) );
        //this.resetGlow();
    },

    // Now would only ever enter ...
    toggleExpanded: function(ui, isExpanded) {

        this.makeExpandedVisibleIndicator( ui, isExpanded );
        this.bringToFront();
        this._showIfAutoDisplay();

    },

    // The visual change/indicator called as part of toggleExpanded routine.
    // Can differ depending on the shape type.
    // Now only entering
    makeExpandedVisibleIndicator: function( ui, isExpanded ) {

        var attrs = isExpanded
            ? this.shapeModel.getNonPathActiveSVGAttrs( this.channel )
            : this.shapeModel.getNonPathInactiveSVGAttrs( this.channel );

        this.el.attr(attrs);

    },

    bringToFront: function() {
        this.el.toFront();

    },

    /*
    * Set the mousedown handler that allows for selection of the shape.
    * */
    _enableSelect: function () { 
        this.el.mousedown( this._selectClickedShape ) ;
    },
    _disableSelect: function() {
        this.el.unmousedown( this._selectClickedShape );
    },
    _selectClickedShape: function(e) {

        // Note: a jq click
        if (e) {
            e.preventDefault();
            e.stopPropagation(); // ( disallows drag )
        }

        var ch = this.channel;

        /**
         * Trigger how shape dealt with and set if the note has toolbar,
         * set it's selected shape to this type.
         * This will trigger this callback noteSubType changed.
         */
        ch.trigger('changeActiveNoteSubtype',  this.shapeModel.deriveShapeSubType(), {
            changeOrigin: 'shapeSelected'
        } );

        // Must set the above before the selected shape
        ch.command('setSelectedShape', this.shapeModel);

    },
    _enableMove: function() { //move from select and unselect
        this.el
            .attr('cursor', 'move')
            .drag(this.moveMove, this.moveStart, this.moveEnd, this, this, this);
    },
    _disableMove: function() {
        this.el
            .attr('cursor', 'pointer')
            .undrag();
    },
    _showIfAutoDisplay: function() {
        this.pgNoteModel.applyAutoDisplayToShapes() && this.el.show();
    },
    _hideIfAutoDisplay: function() {

        // Never hide if the shape is active (DVBC-1608)
        if ( this.shapeUI.get('isActive') )
            return;

        this.pgNoteModel.applyAutoDisplayToShapes() && this.el.hide();

    },
    toggleGlow: function() {

        !this.glow
            ? this._createGlow()
            : this._deleteGlow();

    },
    setResizeFns: function() {

        // TODO: get from note, not global
        var noteSubType = this.channel.request('activeNoteSubType');

        if (noteSubType) {

            _.extend( this, ShapeResizeFnsFactory(noteSubType) );

            // TODO: can now put the if on the subclass ...
            // TODO: others, IE8?
            if (noteSubType === 'free') {
                this.resizeMove = _.throttle(this.resizeMove, 100);
                this.moveMove = _.throttle(this.moveMove, 50);
            }

            _.bindAll(this, 'resizeStart', 'resizeMove', 'resizeEnd');
        }
    },

    /*
    *  TODO ... put on model/view ... is the shape subtype stored on there (?) ... need to model subtype to shape  --- if not do it?
    *  Refactor when can subclass the shape views and models
    * */
    _employBorderViewOnSelect: function() {

        // Commented out -- was exploring utilizing this as compound shape to signify selected shape,
        // but now that F&R shapes can be moved, N/A
        // if (this.shapeModel.isFindAndRedactShape)
        //    return true;

        var subType = this.channel.request('activeNoteSubType');

        return ( subType === 'free' || subType === 'text' || subType === 'signature' ||
            subType === 'graphic_stamp' || subType ==='text_stamp' );

    },

    _createSelectSet: function () {

        var employBorderView = this._employBorderViewOnSelect();

        // TODO: subclass -- breakup creation of select from the dialog buttons )

        if ( ! this.DONT_CREATE_SELECT_HANDLES ) {

            this.handleSet = new SelectHandles({
                parent: this,
                _pathIsRect: this.el.pathIsRect(),
                _hasBorderView: employBorderView,
                _paper: this.el.paper,
                _pgRotation: this.shapeModel.pageModel.get('rotation') % 360 //TODO: put on shape obj, and also on page model doing % 360
            }).render( this.el.paper.set() );

        }


        /* this is the border connecting the drag points */

        // If f&r -- would need slightly different shape -- if we didn't employe the handleset, but now that's not an issue
        if ( employBorderView ) {

            this.borderView = new SelectBoxView({
                parent: this
            }).render(this.el);
        }

        if ( !this.dontCreateButtonSet ) {

            this.btnSet = new BtnSet({
                parent: this,
                channel: this.channel
            });

            // Appears originally used to add new buttons to the set,
            // though b/c its the last element created, can use like an 'afterSelectSelectCreation',
            // (for shapes that create the buttonset).
            // If use case arises where need one but not the other, refactor ...
            this.triggerMethod('after:buttonSetCreation', true);

            // flip if created on fringe of canvas
            this.btnSet.move( this.el.getBBox() );
        }

    },

    _scaleWithPaper: function(scale, lastScale) {

        var args = Array.prototype.slice.call(arguments);
        this._scaleShapeEl(scale, lastScale);

        // Should listen for this event at the the shape level, then pass down to children ...
        this.trigger.apply( this, ['shape.onAfterBaseScale', this.el.getBBox()].concat(args) );
    },

    /* Scales This Shape -- can be over-written in different implementations */
    _scaleShapeEl: function(scale, lastScale) {
        this.el.scalePathWithCurves(scale, lastScale);
    },

    //TODO: use blind destroy's...
    _destroySelectSet: function () {

        if (this.handleSet) {
            this.handleSet.destroy();
            this.handleSet = null;
        }

        if (this.btnSet) {
            this.btnSet.destroy();
            this.btnSet = null;
        }

        if (this.borderView) {
            this.borderView.destroy();
            this.borderView = null;
        }


    },
    onAfterButtonSetCreation: $.noop,

    noteConsultGroupChange: function( ) {

        this.el.attr(
            this.shapeModel.getNonPathActiveSVGAttrs( this.channel )
        );

    },

    /*
     * This is a quick patch for DVBC-1673.
     * It will not be very performant, especially if the page is scaled on drag.
     * Tried other workaround using R.st.scaleWithPaper with this.glow but that is producing a run time error.
     * Leaving in unoptimized for the time-being, given that the whole drawing part of this app needs to be rewritten.
     * Note: placed on baseShape, though only listened to for types that indicate
     * they are expanded by a glow: graphic notes, signatures, graphic stamps, full page redactions.
     * In the future the 'onAfterBaseScale' should be listened to on here and then passed down to children.
     * May also want to may the glow it's own 'subShape.'
     * Update: now also call if change stroke color we glow may exist.
     */
    resetGlow: function() {

        if ( this.glow ) {
            this._deleteGlow();
            this._createGlow();
        }
    },

    _createGlow: function() {


        if ( !this.shapeModel.isFindAndRedactShape )  {

            var fill = this.el.attr('fill'),
                stroke = this.el.attr('stroke'),
                shapeDefinedGlowColor = this.shapeModel.glowColor,
                glowColor = shapeDefinedGlowColor
                    ? shapeDefinedGlowColor
                    : stroke && stroke !== 'none' ? stroke : fill;

            // Quick fix for redaction shape with white fill in 'apply all redactions mode'.
            // If going this route, should define the constants in a central file ...
            // Another option is to make glow color a fn on the redaction shape model and check for the result instead of the property ...
            // But wait until merge with reason codes module which breaks out the shape models for that.
            // Note: this would work over a non-white background ... so perhaps a more complex color function is warranted
            glowColor === '#ffffff'
                && (glowColor = '#000000');


            // Note: bring glow to front
            // Solves: - full page redactions in apply all redactions mode; on both it's own shape and for others, the glow will be behind the full page,
            // when you hover over the notes; to see notes underneath, using can hit toggle expanded, where they are brought to the forefront ( so you don't just see
            // the glow

            this.glow = this.el.glow({
                color: glowColor
            }).toFront();
        }

        else {

            // Testing alternative -- if use can rid reset glow

            this.glow = this.el.glow({
                color: this.el.attr('fill')//, -- daron didn't like 'orange' -- i'm agreeing; i kinda like fill (then also don't need to resetGlow)
                //fill: true,
                //width: 2,
                //offsetx: 2,
                //offsety: 2
            }).toFront();

        }

    },

    _deleteGlow: function() {

        if (!this.glow)
            return;

        this.glow.remove();
        this.glow = null;

    },

    /**
     * Now only done if find and redact -- allows to move/resize and ability to revert to original position.
     * TODO:
     * - a temp POC
     * - now only allowing for coordinate shapes
     * - perhaps put on the model
     */
    persistPosition: function() {

        if ( this.shapeModel.isFindAndRedactShape ) {

            var currentPts =
                this.shapeModel._getPointsFromEl( this.channel.request('currentScaleValue') );

            this.shapeModel.set( 'points', currentPts );

            this.shapeUI.set('isDirty', true); // ( triggers event )

        }

    },

    /* Proxy through channel for use on multiple views */
    getColorToApply: function() {
        return this.channel.request( 'getColorToApplyToShape', this.pgNoteModel, this.shapeModel );
    },


    onBeforeDestroy: function( manualUserDelete ) {

        this._deleteGlow(); // (in case -- eg when called from delete all shapes and converting to floating code on re-render)


        this._destroySelectSet();  //removes all child views (ALSO)
        this.undelegateEvents(); //(uses custom unbind all)
        this.unbindEntityEvents(this.shapeUI, this.shapeUIEvents); //TODO: want the bind entity events on r view composite ...
        this.unbindEntityEvents(this,         this.shapeSubs); /* events triggered off self ... legacy ...*/

        this.stopListening(); // ( in case not covered by Raphael Item View ) -- TODO: check

    }
});


_.extend( ShapeView.prototype, ShapeMoveFns );


module.exports = ShapeView;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/shape.js
 ** module id = 181
 ** module chunks = 0
 **/